module.exports = ".ssf-app-list-item__actions {\n  display: -ms-flexbox;\n  display: flex;\n  margin: 0 -0.5rem; }\n\n.ssf-app-list-item__button {\n  -ms-flex-order: -1;\n      order: -1;\n  margin: 0 0.5rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/applications/components/application-list-item/application-list-item.component.scss
// module id = 793
// module chunks = 3